import { useMemo } from 'react'
//import { useRouteMatch } from 'react-router'
import { useTranslation } from 'react-i18next'
import { AccountTypeNames } from '@medentee/enums'

//import { usePinnedChannels } from 'App/components/Organizations/hooks'
import { accountTypeNameSelector, useAppSelector } from 'store'

import { EventsHighlightRoom, TEventsHighlightRoomProps } from '../EventsHighlightRoom'

import styles from './EventsRoomsNavHighlights.module.scss'

// type TEventsRoomsNavHighlightsProps = {
//   eventId: string
// }

export const EventsRoomsNavHighlights = () => {
  //const match = useRouteMatch<{ path?: string }>(`/events/${eventId}/highlights/:path`)

  // const ids = useAppSelector(selectHighlightedChatIds)
  const accountType = useAppSelector(accountTypeNameSelector)

  // const { pinnedIds } = usePinnedChannels({ ids, entity: 'events', entityId: eventId })

  const { t } = useTranslation()

  //const shouldShowPinnedRooms = Boolean(pinnedIds.length) || match?.isExact

  const highlights: (Omit<TEventsHighlightRoomProps, 'eventId'> & { hidden?: boolean })[] = useMemo(
    () => [
      {
        variant: 'highlights',
        name: t('events.highlights.info'),
        iconVariant: 'info',
        path: 'info'
      },
      {
        hidden: accountType !== AccountTypeNames.PROFESSIONAL,
        variant: 'highlights',
        name: t('events.highlights.profile'),
        iconVariant: 'profile',
        path: 'profile'
      },
      {
        variant: 'highlights',
        name: t('events.highlights.participants'),
        iconVariant: 'networking',
        path: 'networking'
      }
    ],
    [t, accountType]
  )

  return (
    <>
      <div>
        <div className={styles.label}>{t('events.highlights.label')}</div>
        <div className={styles.inlineList}>
          {highlights
            .filter(({ hidden }) => !hidden)
            .map(({ iconVariant, name, path }) => (
              <EventsHighlightRoom
                key={path}
                name={name}
                iconVariant={iconVariant}
                path={`highlights/${path}`}
              />
            ))}
        </div>
      </div>

      {/* {shouldShowPinnedRooms && (
        <div>
          {highlights
            .filter(({ hidden }) => !hidden)
            .filter((item) => item.path === match?.params?.path)
            .map(({ variant, iconVariant, name, path }) => (
              <EventsHighlightRoom
                key={path}
                name={name}
                variant={variant}
                iconVariant={iconVariant}
                path={path}
                eventId={eventId}
              />
            ))}
        </div>
      )} */}
    </>
  )
}
